import { render, staticRenderFns } from "./OrdersByProductOverTime.vue?vue&type=template&id=2a624fd0&scoped=true"
import script from "./OrdersByProductOverTime.vue?vue&type=script&lang=js"
export * from "./OrdersByProductOverTime.vue?vue&type=script&lang=js"
import style0 from "./OrdersByProductOverTime.vue?vue&type=style&index=0&id=2a624fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a624fd0",
  null
  
)

export default component.exports